export function safeGet(fn, defaultValue = undefined, acceptUndefined = false) {
  try {
    const result = fn()
    return result === undefined && !acceptUndefined ? defaultValue : result
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      /*
      console.log('--- SAFE GET ---')
      console.log(error)
      */
    }
    return defaultValue
  }
}
